import { NewDialog, Password, Select, Text, Radio, Switch, Button } from '@104ha/base-ui';
import { Col } from '../../components/col';
import { FormGroup, Label } from '../../components/form';
import { dialogWidth, dialogHeight, formError, accountMaxText } from './const';
import { IPV4, IPV6 } from '../../constant/regex';
import { customAlphabet } from 'nanoid';

const nanoid = customAlphabet('1234567890QAZWSXEDCRFVTGBYHNUJMIKOLP', 40);

const inputs = {
	userAccount: null,
	userName: null,
	pwd: null,
	rePwd: null,
	userIpType: null,
	userIp: null,
	authMode: null,
	userToken: null,
	accountStatus: null,
};

type Keys = keyof typeof inputs;

class NewAccountDialog extends NewDialog {
	static defaultProps = {
		...NewDialog.defaultProps,
		title: '新增API使用者連接帳號',
		width: dialogWidth,
		height: dialogHeight,
		api: '/api/manage/privilege/account/new',
		errCode: formError,
		successMsg: '新增帳號完成',
	};

	state: {
		ipType: 1 | 2;
		authMode: 1 | 2;
		userToken: '';
		accountStatus: 3 | 4;
	} = {
		...this.state,
		ipType: 1,
		authMode: 1,
		userToken: '',
		accountStatus: 3,
	};

	inputs: {
		[key in Keys]?: {
			getValue: () => any;
			setState: (params: any) => any;
		} | null;
	} = inputs;

	validate() {
		let v = super.validate();
		if (!v) return v;

		const { userIp, userIpType } = this.inputs;
		const userIpTypeValue = userIpType?.getValue();

		let ipValidate = true;
		let userTokenValidate = true;
		let ips = (userIp?.getValue() || '').split(';');
		const isEmptyIpList = ips.length === 1 && ips[0] === '';

		if (this.state.authMode === 1 && isEmptyIpList) return v;

		if (userIpTypeValue === 1) {
			ipValidate = ips.findIndex((ip: string) => !IPV4.test(ip)) < 0;
		}

		if (userIpTypeValue === 2) {
			ipValidate = ips.findIndex((ip: string) => !IPV6.test(ip)) < 0;
		}

		if (!ipValidate) {
			userIp?.setState({ error: 'IP格式錯誤' });
		}

		return v && ipValidate;
	}

	getValues() {
		const values = super.getValues();
		return {
			...values,
			userToken: this.state.userToken,
			accountStatus: values.accountStatus === 1 ? 3 : 4,
		};
	}

	renderBody() {
		// const { empId, tempUnit } = this.state;
		return (
			<>
				<FormGroup>
					<Label required>API登入帳號</Label>
					<Col span={16}>
						<Text
							{...{
								ref: (ele: any) => (this.inputs.userAccount = ele),
								validate: {
									required: true,
									max: accountMaxText,
								},
							}}
						/>
					</Col>
				</FormGroup>
				<FormGroup>
					<Label required>帳號名稱</Label>
					<Col span={16}>
						<Text
							{...{
								ref: (ele: any) => (this.inputs.userName = ele),
								validate: {
									required: true,
									max: accountMaxText,
								},
							}}
						/>
					</Col>
				</FormGroup>
				<FormGroup>
					<Label required>API串接模式</Label>
					<Col span={16}>
						<Radio
							{...{
								ref: (ele: any) => (this.inputs.authMode = ele),
								data: { 1: 'Token串接模式', 2: 'API 金鑰模式' },
								initValue: 1,
								validate: {
									required: true,
								},
								onUpdate: (authMode) => this.setState({ authMode }),
							}}
						/>
					</Col>
				</FormGroup>
				{this.state.authMode === 1 ? (
					<>
						<FormGroup>
							<Label required>密碼</Label>
							<Col span={16}>
								<Password
									{...{
										ref: (ele: any) => (this.inputs.pwd = ele),
										validate: {
											required: true,
											max: accountMaxText,
										},
										autoComplete: 'new-password',
									}}
								/>
							</Col>
						</FormGroup>
						<FormGroup>
							<Label required>再次輸入密碼</Label>
							<Col span={16}>
								<Password
									{...{
										ref: (ele: any) => (this.inputs.rePwd = ele),
										validate: {
											required: true,
											max: accountMaxText,
										},
									}}
								/>
							</Col>
						</FormGroup>
					</>
				) : null}
				<FormGroup>
					<Label>連接IP位置限制</Label>
					<Col span={16}>
						<Col span={8}>
							<Select
								ref={(ele: any) => (this.inputs.userIpType = ele)}
								data={{ 1: 'IPV4', 2: 'IPV6' }}
								initValue={1}
								onUpdate={(v) => {
									this.setState({ ipType: v });
								}}
							></Select>
						</Col>
						<Col>
							<Text
								{...{
									ref: (ele: any) => (this.inputs.userIp = ele),
									placeholder:
										this.state.ipType === 1
											? 'ex. 192.168.0.1;192.168.0.*'
											: 'ex: ffff:ffff:ffff:ffff:ffff:ffff:ffff:ffff',
									validate: {
										required: this.state.authMode === 2,
									},
								}}
							/>
						</Col>
					</Col>
				</FormGroup>
				<FormGroup>
					<Label required>帳號狀態</Label>
					<Col span={16}>
						<Switch
							{...{
								ref: (ele: any) => (this.inputs.accountStatus = ele),
								data: { 0: '關閉', 1: '開啟' },
								initValue: 1,
								validate: {
									required: true,
								},
							}}
						/>
					</Col>
				</FormGroup>
				{this.state.authMode === 2 ? (
					<>
						<FormGroup>
							<Label required>金鑰</Label>
							<Col span={3}>
								<Button.One
									onClick={() => {
										const userToken = nanoid();
										this.setState({ userToken });
									}}
								>
									產生
								</Button.One>
							</Col>
							<Col span={13}>
								<p style={{ wordBreak: 'break-all' }}>{this.state.userToken}</p>
							</Col>
						</FormGroup>
					</>
				) : null}
			</>
		);
	}
}

export { NewAccountDialog };
